import { Box } from "@mui/material";
import { Scrollbar } from "app/components/Scrollbar";
import { WorkspacesPopover } from "app/layout/main/components/workspace/WorkspacesPopover";
import { useAppNavigation } from "src/navigation";

import {
  NavigationItem as NavigationItemType,
  NavigationSlotsProps,
} from "../types";
import { NavigationItem } from "./NavigationItem";

export const NavigationContent = ({
  onNavigationItemSelected,
  slots,
}: NavigationSlotsProps & {
  onNavigationItemSelected?: (item: NavigationItemType) => void;
}) => {
  const navigationItems = useAppNavigation();
  return (
    <>
      {slots?.topArea}

      <WorkspacesPopover sx={{ my: 2 }} />

      <Scrollbar fillContent>
        <Box
          component="nav"
          display="flex"
          flex="1 1 auto"
          flexDirection="column"
        >
          <Box component="ul" display="flex" flexDirection="column" gap={0.5}>
            {navigationItems.map((item) => (
              <NavigationItem
                key={item.path}
                navigationItem={item}
                onClick={() => onNavigationItemSelected?.(item)}
              />
            ))}
          </Box>
        </Box>
      </Scrollbar>

      {slots?.bottomArea}
    </>
  );
};
